module.exports = __webpack_public_path__ + "image_prod.png?c71e05bccc5ee8bea752d2b9812370d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_prod.png
// module id = 483
// module chunks = 0